gsap.to('.header-bg', {
    scale: 1.5,
    scrollTrigger: {
      trigger: '.header-bg',
      scrub: 0.5,
      start: 'top center',
      end: 'bottom top',
      markers: false,
    }
});